import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactSVG from 'react-svg';
import Loader from './Loader';

class Buttons extends React.Component {
  state = {
    hover: false,
  }

  icon(isVisible) {
    if (!this.props.icon) return;

    let size;
    const large = 14;
    const medium = 14;
    const small = 12.55;
    const extraSmall = 10.5;
    const defaultSize = 14;
    switch (this.props.size) {
      case 'large':
        size = large; break;
      case 'medium':
        size = medium; break;
      case 'small':
        size = small; break;
      case 'extra-small':
        size = extraSmall; break;
      default:
        size = defaultSize;
    }

    if (typeof this.props.icon === 'object') {
      return (
        <div
          style={{
            display: 'contents',
            width: 'unset',
            height: 'unset',
            marginRight: this.props.text ? '9px' : 0,
            visibility: isVisible ? 'visible' : 'hidden'
          }}
        >
          {this.props.icon}
        </div>
      );
    } else if (typeof this.props.icon === 'function') {
      const addSize = 10;
      return (
        <div
          style={{
            display: 'contents',
            width: 'unset',
            height: 'unset',
            visibility: isVisible ? 'visible' : 'hidden'
          }}
        >
          {this.props.type === 'line' && this.state.hover ?
            <this.props.icon width={size + addSize} height={size + addSize} color="#FFFFFF" style={{ marginRight: this.props.text ? '9px' : 0 }} /> :
            <this.props.icon width={size + addSize} height={size + addSize} color="#1A65FF" style={{ marginRight: this.props.text ? '9px' : 0 }} />
          }
        </div>
      )
    } else {
      return (
        <ReactSVG
          path={this.props.icon}
          svgStyle={{ width: size, height: size }}
          className="icon"
          style={{
            marginRight: this.props.text ? '9px' : 0,
            visibility: isVisible ? 'visible' : 'hidden'
          }}
        />
      )
    }
  }

  render() {
    const {
      type,
      size,
      color,
      fullWidth,
      disabled,
      handleClickButton,
      text,
      icon: _icon,
      loading,
      ...rest
    } = this.props;

    let loaderColor = "light";
    if (type === "line") {
      loaderColor = this.state.hover ? "light" : "color";
    }
    if (type === "ghost") loaderColor = "dark";

    let isLoading = loading && !!text && !disabled; //icon-only or disabled button will not have loading UI

    return (
      <Button
        className={`${color} ${disabled ? 'disabled' : type} ${size} ${fullWidth ? 'fullWidth' : ''} ${isLoading ? 'loading' : ''}`}
        disabled={disabled}
        onClick={handleClickButton}
        hasText={!!text}
        onMouseEnter={() => { this.setState({ hover: true }) }}
        onMouseLeave={() => { this.setState({ hover: false }) }}
        {...rest}
      >
        <div className="content">
          <Loader size={size === "large" ? "medium" : size} type={loaderColor} style={{ visibility: isLoading ? 'visible' : 'hidden' }} />
          {this.icon(!isLoading)}
          <span style={{ visibility: isLoading ? 'hidden' : 'inherit' }}>{text}</span>
        </div>
      </Button>
    )
  }
}

Buttons.defaultProps = {
  type: 'default',
  size: 'medium',
  color: 'blue',
  disabled: false,
  handleClickButton: () => { },
  icon: '',
  fullWidth: false,
  loading: false,
}

Buttons.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  handleClickButton: PropTypes.func,
  icon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object,
  ]),
  fullWidth: PropTypes.bool,
  loading: PropTypes.bool,
}

const Button = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  background: #fff;
  height: 38px;
  padding: ${props => props.hasText ? '0 20px' : '0 12px'}
  -webkit-appearance: none;
  -moz-appearance: none;
  outline-style: none;
  border-radius: 2px;
  font-size: 15px;
  font-weight: 300;
  font-family: inherit;
  box-sizing: border-box;
  cursor: pointer;
  outline: 0;
  transition: all 120ms linear;

  &.large {
    padding: 0 26px;
    padding: ${props => props.hasText ? '0 26px' : '0 17px'}
    height: 48px;
    font-size: 15px;
    min-width: ${props => props.hasText ? '160px' : 'unset'};
    & .icon {
      width: 14px;
      height: 14px;
    }
  }

  &.medium {
    padding: 0 20px;
    padding: ${props => props.hasText ? '0 20px' : '0 11.5px'}
    height: 38px;
    font-size: 15px;
    min-width: ${props => props.hasText ? '120px' : 'unset'};
    & .icon {
      width: 14px;
      height: 14px;
    }
  }

  &.small {
    padding: 0 16px;
    padding: ${props => props.hasText ? '0 18px' : '0 10.38px'}
    height: 33px;
    font-size: 13px;
    min-width: ${props => props.hasText ? '100px' : 'unset'};
    & .icon {
      width: 12.5px;
      height: 12.5px;
    }
  }

  &.extra-small {
    padding: 0 16px;
    padding: ${props => props.hasText ? '0 16px' : '0 9.75px'}
    height: 30px;
    font-size: 11px;
    min-width: ${props => props.hasText ? '80px' : 'unset'};
    & .icon {
      width: 10.5px;
      height: 10.5px;
    }
  }

  &.loading {
    pointer-events: none;
  }

  &.disabled {
    opacity: 1;
    cursor: default;
    pointer-events: none;
    background: #F4F6F9 !important;
    color: #B1B3B9;
    border: 1px solid #D8DBDF;
    & .icon svg path {
      fill: #B1B3B9;
    }
  }

  &.red {
    background: #F03A47;
    &:hover::before {
      background: #F03A47;
        opacity: .6;
    }
  }

  &.blue {
    background: #1A65FF;
    &:hover::before {
        background: #1A65FF;
        opacity: .6;
    }
  }

  &.default {
      color: #fff;
      border: none;
      & .icon svg path {
          fill: #fff;
      }
      &:hover{
          background: white;
      }
      &:hover::before{
          position: absolute;
          content: "";
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          transition: all 0.5s;
          -webkit-transition: all 0.5s;
      }
  }

  &.line {
    background: transparent;
    color: #1A65FF;
    border: 1px solid #1A65FF;
    & .icon svg path {
      fill: #1A65FF;
    }
    &:hover {
      opacity: 1;
      background: #1A65FF;
      color: #fff;
      & .icon svg path {
        fill: #fff;
      }
    }
  }

  &.ghost {
    opacity: 1;
    background: #fff;
    color: #181819;
    border: 1px solid #D8DBDF;
    & .icon svg path {
      fill: #181819;
    }
    &:hover::before{
        position: absolute;
        content: "";
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        transition: all 0.5s;
        -webkit-transition: all 0.5s;
        background: rgba(0,0,0,.05);
    }
  }

  & .icon {
    width: 14px;
    height: 14px;
  }

  &.fullWidth {
    width: 100%;
    justify-content: center;
  }

  & .content {
      display: inherit;
      align-items: inherit;
      justify-content: inherit;
      position: relative;
      width: 100%;
  }
`

export default Buttons;



// WEBPACK FOOTER //
// ./src/components/Parts/Button.jsx